import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/painelOperador.css';
import '../styles/gestaoBpoRh.css';

// Fechamento do mês para o CLIENTE: uma linha por empresa com o que aconteceu na
// competência (pessoas, admissões, rescisões, férias, VA/HO/VT, folha) e o envio
// do resumo por e-mail — sempre com prévia; o Enviar fica dentro dela.
const API = process.env.REACT_APP_API_BASE;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });
const mesAtual = () => { const d = new Date(); d.setMonth(d.getMonth() - 1); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };
const brl = (v) => (v == null ? '—' : `R$ ${Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
const kb = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

const BpoRhFechamentoCliente = () => {
  const [mes, setMes] = useState(mesAtual());
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState('');
  const [envio, setEnvio] = useState(null);   // {cliente, carregando, previa, form, enviando, erro}

  const carregar = useCallback(() => {
    setCarregando(true); setErro('');
    axios.get(`${API}/api/bporh/fechamento-cliente/`, { params: { mes, _: Date.now() }, headers: headers() })
      .then((r) => setDados(r.data))
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível carregar os fechamentos'))
      .finally(() => setCarregando(false));
  }, [mes]);
  useEffect(() => { carregar(); }, [carregar]);

  const previa = (cliente, form) => {
    setEnvio((s) => ({ ...(s || {}), cliente, carregando: true, form: form || s?.form, erro: null }));
    const corpo = { cliente_id: cliente.cliente_id, mes, enviar: false };
    if (form) {
      if (form.operador_id) corpo.operador_id = Number(form.operador_id);
      corpo.destinatarios = form.destinatarios || ''; corpo.copia = form.copia || '';
      corpo.copia_bi = !!form.copia_bi;
    }
    axios.post(`${API}/api/bporh/fechamento-cliente/`, corpo, { headers: headers() })
      .then((r) => {
        const p = r.data.previa;
        setEnvio({ cliente, carregando: false, enviando: false, previa: p,
          form: form || { operador_id: p.operador_id || '', destinatarios: p.destinatarios || '',
            copia: p.copia || '', copia_bi: !!p.copia_bi } });
      })
      .catch((e) => { setEnvio(null); setErro(e.response?.data?.mensagem || 'Não foi possível montar a prévia'); });
  };
  // guarda os e-mails do cliente sem enviar nada
  const salvarEmails = () => {
    const { cliente, form } = envio;
    setEnvio((s) => ({ ...s, salvando: true, erro: null }));
    axios.post(`${API}/api/bporh/fechamento-cliente/`, {
      cliente_id: cliente.cliente_id, mes, acao: 'salvar_emails', destinatarios: form.destinatarios,
      copia: form.copia, copia_bi: !!form.copia_bi,
    }, { headers: headers() })
      .then((r) => { setEnvio((s) => ({ ...s, salvando: false, salvo: r.data.mensagem })); carregar(); })
      .catch((e) => setEnvio((s) => ({ ...s, salvando: false, erro: e.response?.data?.mensagem || 'Não foi possível salvar' })));
  };
  const enviar = () => {
    const { cliente, previa: p, form } = envio;
    setEnvio((s) => ({ ...s, enviando: true, erro: null }));
    axios.post(`${API}/api/bporh/fechamento-cliente/`, {
      cliente_id: cliente.cliente_id, mes, enviar: true, operador_id: Number(form.operador_id),
      destinatarios: form.destinatarios, copia: form.copia, copia_bi: !!form.copia_bi,
      assunto: p.assunto, conteudo_html: p.conteudo_html,
    }, { headers: headers() })
      .then((r) => { setEnvio(null); setErro(''); window.alert(r.data.mensagem); carregar(); })
      .catch((e) => setEnvio((s) => ({ ...s, enviando: false, erro: e.response?.data?.mensagem || 'Não foi possível enviar' })));
  };

  const lista = (dados?.clientes || []).filter((c) => !busca || `${c.cliente} ${c.operador || ''}`.toLowerCase().includes(busca.toLowerCase()));
  const tot = (k) => lista.reduce((s, c) => s + (Number(c[k]) || 0), 0);

  return (
    <div className="painel-op">
      <div className="container-fluid mt-4 shadow p-4 rounded bg-white">
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center">
            <i className="fas fa-envelope-open-text header-icon me-2" aria-hidden="true"></i>
            <h2 className="titulo-pagina m-0">BPO RH — Fechamento do mês{dados && <span className="text-muted"> · {dados.mes_rotulo}</span>}</h2>
          </div>
          <div className="gr-toolbar">
            <label className="gr-campo" title="Competência do fechamento">
              <i className="fas fa-calendar-days" aria-hidden="true"></i>Competência
              <input type="month" value={mes} onChange={(e) => e.target.value && setMes(e.target.value)} aria-label="Competência" />
            </label>
            <label className="gr-campo" title="Filtrar empresa">
              <i className="fas fa-magnifying-glass" aria-hidden="true"></i>
              <input type="text" placeholder="empresa ou operadora" value={busca} onChange={(e) => setBusca(e.target.value)}
                style={{ border: 0, outline: 0, background: 'transparent', width: 170, height: 34, fontSize: 13.5 }} />
            </label>
            <Link to="/BpoRh/Gestao" className="gr-btn"><i className="fas fa-chart-line" aria-hidden="true"></i>Gestão</Link>
            <button type="button" className="gr-btn primaria" onClick={carregar} disabled={carregando}>
              <i className={`fas ${carregando ? 'fa-spinner fa-spin' : 'fa-rotate'}`} aria-hidden="true"></i>Atualizar
            </button>
          </div>
        </div>

        <div className="alert alert-light border small py-2">
          <i className="fas fa-circle-info me-2 text-primary"></i>
          Uma linha por empresa com o que aconteceu em <b>{dados?.mes_rotulo || 'no mês'}</b>: quadro de pessoas, admissões, desligamentos,
          férias, VA · home office · VT pagos e as variáveis da folha. <b>Prévia e envio</b> monta o e-mail para o cliente — com o detalhe
          por colaborador em Excel — e nada sai sem você conferir e clicar em Enviar.
        </div>
        {erro && <div className="alert alert-danger py-2"><i className="fas fa-circle-exclamation me-2"></i>{erro}</div>}

        {carregando && !dados ? (
          <div className="text-center py-5 text-muted"><i className="fas fa-spinner fa-spin fa-3x mb-3" style={{ color: '#00b5cc' }}></i><div className="fs-5">Levantando o mês de cada empresa...</div></div>
        ) : (
          <section className="po-card po-enter">
            <header className="po-card-head">
              <h3><i className="fas fa-building" aria-hidden="true"></i>Empresas</h3>
              <span className="badge bg-light text-dark">{lista.length}</span>
              <span className="po-sub">{lista.filter((c) => c.envio).length} já enviada(s) nesta competência</span>
            </header>
            <div className="po-card-body">
              <div className="po-scroll">
                <table className="table table-hover po-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Empresa</th><th className="text-end">Ativos</th><th className="text-end">Entradas</th><th className="text-end">Saídas</th>
                      <th className="text-end">Líquido</th><th className="text-end">Férias</th><th className="text-end" title="Férias que começam nos próximos 90 dias (entre parênteses: ainda em aprovação)">Próximas</th>
                      <th className="text-end">VA</th><th className="text-end">Home office</th><th className="text-end">VT</th><th className="text-end">Benefícios</th>
                      <th>Folha</th><th>Enviado</th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {lista.map((c) => (
                      <tr key={c.cliente_id}>
                        <td><div className="po-nome">{c.cliente}</div><div className="po-sub">{c.operador || '—'}{c.emails ? ` · ${c.emails}` : ' · sem e-mail cadastrado'}</div></td>
                        <td className="text-end tabular">{c.ativos}</td>
                        <td className="text-end tabular" style={{ color: c.entradas ? '#2e8b57' : undefined }}>{c.entradas ? `+${c.entradas}` : '—'}</td>
                        <td className="text-end tabular" style={{ color: c.saidas ? '#b3261e' : undefined }}>{c.saidas ? `−${c.saidas}` : '—'}</td>
                        <td className="text-end tabular fw-bold">{c.liquido > 0 ? `+${c.liquido}` : c.liquido}</td>
                        <td className="text-end tabular">{c.ferias || '—'}</td>
                        <td className="text-end tabular">{c.proximas_ferias ? <>{c.proximas_ferias}{c.proximas_pendentes ? <span className="text-muted"> ({c.proximas_pendentes})</span> : ''}</> : '—'}</td>
                        <td className="text-end tabular">{c.va ? brl(c.va) : '—'}</td>
                        <td className="text-end tabular">{c.ho ? brl(c.ho) : '—'}</td>
                        <td className="text-end tabular">{c.vt ? brl(c.vt) : '—'}</td>
                        <td className="text-end tabular fw-bold">{c.beneficios ? brl(c.beneficios) : '—'}</td>
                        <td>
                          {c.tem_folha ? (c.folha_fechada
                            ? <span className="badge bg-success" title={`variáveis lançadas: ${brl(c.folha_total)}`}><i className="fas fa-lock me-1"></i>fechada{c.folha_total ? ` · ${brl(c.folha_total)}` : ''}</span>
                            : <span className="badge bg-warning text-dark" title="A folha ainda não foi fechada — os valores do e-mail podem mudar">aberta</span>)
                            : <span className="text-muted">—</span>}
                        </td>
                        <td>{c.envio
                          ? <span className="small" title={`para ${c.envio.para}`}><i className="fas fa-circle-check text-success me-1"></i>{c.envio.em}<div className="po-sub">por {c.envio.por}{c.envio.vezes > 1 ? ` · ${c.envio.vezes}×` : ''}</div></span>
                          : <span className="text-muted small">não</span>}</td>
                        <td className="text-end">
                          <button type="button" className={`btn btn-sm ${c.envio ? 'btn-light border' : 'btn-outline-primary'}`} onClick={() => previa(c, null)}
                            disabled={envio?.carregando} title="Monta o e-mail do fechamento desta empresa e mostra a prévia">
                            <i className={`fas ${envio?.carregando && envio?.cliente?.cliente_id === c.cliente_id ? 'fa-spinner fa-spin' : 'fa-envelope-open-text'} me-1`}></i>Prévia e envio
                          </button>
                        </td>
                      </tr>
                    ))}
                    {lista.length === 0 && <tr><td colSpan={14} className="text-center text-muted py-4">Nenhuma empresa neste filtro.</td></tr>}
                  </tbody>
                  {lista.length > 1 && (
                    <tfoot>
                      <tr className="fw-bold" style={{ background: '#f8f9fa' }}>
                        <td>Total</td><td className="text-end tabular">{tot('ativos')}</td><td className="text-end tabular">+{tot('entradas')}</td><td className="text-end tabular">−{tot('saidas')}</td>
                        <td className="text-end tabular">{tot('liquido')}</td><td className="text-end tabular">{tot('ferias')}</td><td className="text-end tabular">{tot('proximas_ferias')}</td>
                        <td className="text-end tabular">{brl(tot('va'))}</td><td className="text-end tabular">{brl(tot('ho'))}</td><td className="text-end tabular">{brl(tot('vt'))}</td>
                        <td className="text-end tabular">{brl(tot('beneficios'))}</td><td colSpan={3}></td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          </section>
        )}
      </div>

      {/* ─── Modal: prévia e envio ─── */}
      {envio && (envio.previa || envio.carregando) && (() => {
        const p = envio.previa || {};
        const form = envio.form || {};
        const setForm = (patch) => setEnvio((s) => ({ ...s, form: { ...s.form, ...patch } }));
        const pronto = !envio.carregando && p.assunto && form.operador_id && (form.destinatarios || '').trim();
        const r = p.resumo || {};
        return (
          <div className="modal" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ maxWidth: 980 }}>
              <div className="modal-content shadow-lg">
                <div className="modal-header" style={{ background: '#fff', borderBottom: '1px solid #e9ecef' }}>
                  <div>
                    <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}><i className="fas fa-envelope-open-text me-2"></i>Fechamento de {dados?.mes_rotulo} — {envio.cliente.cliente}</h5>
                    <small style={{ color: '#6c757d' }}>e-mail para o cliente com o resumo do mês e o Excel por colaborador</small>
                  </div>
                  <button type="button" className="btn-close" onClick={() => setEnvio(null)} disabled={envio.enviando}></button>
                </div>
                <div className="modal-body">
                  {envio.carregando && !p.assunto ? (
                    <div className="text-center py-5 text-muted"><i className="fas fa-spinner fa-spin fa-2x mb-2" style={{ color: '#00b5cc' }}></i><div>Montando o resumo, as variáveis da folha e o Excel...</div></div>
                  ) : (
                    <>
                      {envio.erro && <div className="alert alert-danger py-2 small"><i className="fas fa-circle-exclamation me-2"></i>{envio.erro}</div>}
                      {r.folha_status && !r.folha_status.fechada && (
                        <div className="alert alert-warning small py-2"><i className="fas fa-lock-open me-2"></i>A folha desta competência ainda não está fechada — as variáveis do e-mail são o cálculo de agora. O ideal é fechar a folha antes de enviar.</div>
                      )}
                      <div className="row g-2 align-items-end mb-2">
                        <div className="col-md-3">
                          <label className="form-label small fw-bold mb-1 text-muted">Quem envia</label>
                          <select className="form-select form-select-sm" value={form.operador_id || ''} onChange={(e) => setForm({ operador_id: e.target.value })}>
                            <option value="">— operador —</option>
                            {(p.operadores || []).map((o) => <option key={o.id} value={o.id} disabled={!o.pronto}>{o.nome}{o.pronto ? '' : ' (sem senha de app)'}</option>)}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label small fw-bold mb-1 text-muted">Para (e-mail do cliente)</label>
                          <input type="text" className="form-control form-control-sm" placeholder="financeiro@cliente.com; rh@cliente.com" value={form.destinatarios || ''} onChange={(e) => setForm({ destinatarios: e.target.value })} />
                        </div>
                        <div className="col-md-9">
                          <label className="form-label small fw-bold mb-1 text-muted">Cópia (opcional)</label>
                          <input type="text" className="form-control form-control-sm" placeholder="contabilidade@cliente.com" value={form.copia || ''} onChange={(e) => setForm({ copia: e.target.value })} />
                        </div>
                        <div className="col-md-3 d-flex gap-1">
                          <button type="button" className="btn btn-sm btn-outline-secondary flex-grow-1" onClick={salvarEmails}
                            disabled={envio.salvando || !(form.destinatarios || '').trim()} title="Guardar estes e-mails para os próximos fechamentos, sem enviar">
                            <i className={`fas ${envio.salvando ? 'fa-spinner fa-spin' : 'fa-floppy-disk'} me-1`}></i>Salvar
                          </button>
                          <button type="button" className="btn btn-sm btn-outline-primary flex-grow-1" onClick={() => previa(envio.cliente, form)} disabled={envio.carregando} title="Refazer a prévia com estes e-mails">
                            <i className={`fas ${envio.carregando ? 'fa-spinner fa-spin' : 'fa-rotate'}`}></i>
                          </button>
                        </div>
                      </div>
                      {/* BI da Gerencial vai sempre em cópia (30/09/2026) — não é mais opção */}
                      <div className="small text-muted mb-2">
                        <i className="fas fa-copy me-1"></i>
                        Cópia automática para <b>{p.copia_bi_email || 'automacoes@comecehub.com.br; angelo@gerencialconsultoria.com.br'}</b> (BI e Angelo)
                      </div>
                      <div className="form-text mb-2">
                        {envio.salvo ? <span className="text-success"><i className="fas fa-circle-check me-1"></i>{envio.salvo}</span> : 'Clique em Salvar para guardar os e-mails e esta escolha para os próximos meses.'}
                      </div>

                      <div className="row g-2 mb-2 small">
                        {r.pessoas && (
                          <div className="col-md-4"><div className="border rounded p-2 h-100"><div className="fw-bold text-muted">Pessoas</div>
                            <div>{r.pessoas.ativos} ativos · +{r.pessoas.entradas} / −{r.pessoas.saidas} · líquido {r.pessoas.liquido > 0 ? '+' : ''}{r.pessoas.liquido} · {r.ferias} em férias · {(r.proximas_ferias || []).length} programada(s)</div></div></div>
                        )}
                        {r.beneficios && (
                          <div className="col-md-4"><div className="border rounded p-2 h-100"><div className="fw-bold text-muted">Benefícios pagos</div>
                            <div>VA {brl(r.beneficios.va.total)} · HO {brl(r.beneficios.ho.total)} · VT {brl(r.beneficios.vt.total)} · <b>{brl(r.beneficios.total)}</b></div></div></div>
                        )}
                        <div className="col-md-4"><div className="border rounded p-2 h-100"><div className="fw-bold text-muted">Folha (variáveis)</div>
                          <div>{(r.folha || []).length ? r.folha.slice(0, 4).map((x) => `${x.rotulo} ${x.unidade === 'horas' ? `${x.total} h` : brl(x.total)}`).join(' · ') : 'sem variáveis lançadas'}</div></div></div>
                      </div>

                      <div className="small mb-2">
                        <div><b>Assunto:</b> {p.assunto}</div>
                        <div><b>De:</b> {p.remetente || '—'}</div>
                        <div><b>Para:</b> {form.destinatarios || <span className="text-danger">informe o e-mail do cliente</span>}</div>
                        {(form.copia || p.copia_bi_email) && (
                          <div><b>Cópia:</b> {[form.copia, p.copia_bi_email || ''].filter(Boolean).join('; ')}</div>
                        )}
                        <div><b>Anexo:</b> {(p.anexos || []).map((a) => `${a.nome} (${kb(a.tamanho)}) — ${a.descricao}`).join(', ')}</div>
                      </div>
                      <div className="border rounded" style={{ maxHeight: 380, overflow: 'auto' }}>
                        {/* sandbox="" obrigatório: srcdoc herda a origem do app */}
                        <iframe title="Prévia do fechamento" srcDoc={p.corpo_previa || p.corpo_html} sandbox="" style={{ width: '100%', height: 380, border: 0 }} />
                      </div>
                      {(p.historico || []).length > 0 && (
                        <>
                          <div className="small fw-bold text-muted mt-3 mb-1"><i className="fas fa-clock-rotate-left me-1"></i>Já enviados nesta competência</div>
                          {p.historico.map((h, i) => <div key={i} className="small text-muted border-bottom py-1"><b style={{ color: '#212529' }}>{h.enviado_em}</b> · {h.destinatarios}{h.enviado_por ? ` · por ${h.enviado_por}` : ''}</div>)}
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className="modal-footer" style={{ borderTop: '1px solid #e9ecef' }}>
                  <span className="small text-muted me-auto">Nada é enviado sem você clicar em Enviar.</span>
                  <button type="button" className="btn btn-light border btn-sm" onClick={() => setEnvio(null)} disabled={envio.enviando}>Fechar</button>
                  <button type="button" className="btn btn-success btn-sm" onClick={enviar} disabled={!pronto || envio.enviando}
                    title={!pronto ? 'Escolha o operador e informe o e-mail do cliente' : undefined}>
                    <i className={`fas ${envio.enviando ? 'fa-spinner fa-spin' : 'fa-paper-plane'} me-2`}></i>{envio.enviando ? 'Enviando...' : 'Enviar ao cliente'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default BpoRhFechamentoCliente;
